export function encode(text: string): string {
  if (typeof window !== "undefined" && typeof btoa !== "undefined") {
    return btoa(text);
  }

  if (typeof Buffer !== "undefined") {
    return Buffer.from(text).toString("base64");
  }

  return text;
}

export function decode(text: string): string {
  if (typeof window !== "undefined" && typeof atob !== "undefined") {
    return atob(text);
  }

  if (typeof Buffer !== "undefined") {
    return Buffer.from(text, "base64").toString();
  }

  return text;
}

export function base64toBlob(base64: string, mimeType: string): Blob {
  const binary = decode(base64);
  const array = [];
  for (let i = 0; i < binary.length; i++) {
    array.push(binary.charCodeAt(i));
  }
  return new Blob([new Uint8Array(array)], { type: mimeType });
}
